import { formatPrice, type CommissionSummary } from "@nh/shared";

/**
 * Las OTRAS monedas del resumen, para el `hint` de una tarjeta: el
 * número grande es la moneda del país del socio; si además tiene
 * comisiones en la otra, se dice aparte en vez de sumarse (14-sep-2026).
 *
 * Devuelve `undefined` cuando no hay nada más que decir.
 */
export function otherBalancesHint(
  summary: CommissionSummary | undefined,
  field: "pendingCents" | "releasedCents" | "paidCents",
): string | undefined {
  if (!summary) return undefined;
  const others = summary.balances
    .filter((balance) => balance.currency !== summary.currency && balance[field] > 0)
    .map((balance) => `${formatPrice(balance[field], balance.currency)} ${balance.currency}`);
  return others.length ? `+ ${others.join(" · ")}` : undefined;
}
